module.exports = __webpack_public_path__ + "assets/images/spor_fm_tv_logo_v2_1.ea6e37ed29d4420266cb2197441995e7.png";